import { swRequest, getSessionKey } from "@sourcewhale/core";

export const getUser = () => {
  let params = {
    sessionKey: getSessionKey(),
    href: window.location.href,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };

  if (typeof window !== "undefined" && window?.origin.includes("sourcewhale")) {
    params = {
      ...params,
      sw: window.screen.width,
      sh: window.screen.height,
      vw: window.innerWidth,
      vh: window.innerHeight,
    };
  }

  return swRequest({
    path: "/api/users/get",
    params,
  });
};

export const saveUser = (data, opts = {}) =>
  swRequest(
    {
      path: "/api/users/save",
      method: "POST",
      body: data,
    },
    opts,
  );

export const getUsers = (params) =>
  swRequest({
    path: "/api/users/get_all",
    method: "GET",
    params,
  });

export const getTodos = (params, opts = {}) =>
  swRequest(
    {
      path: "/api/users/get_todos",
      method: "GET",
      params,
    },
    opts,
  );

// NB only gets user/superUser licenses
export const getUserLicenses = (params) =>
  swRequest({
    path: "/internal-api/admin/database_query",
    method: "GET",
    params: {
      kind: "getUserLicenses",
      ...params,
    },
  });

export const updateUser = (body) =>
  swRequest({
    path: "/api/users/save",
    method: "POST",
    body,
  });
